import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useEffect, useRef, useState } from "react";
import { Download, X } from "react-feather";

import "../../home/controls/Confirmation.css";
import "./DownloadTokensModal.css";

export default NiceModal.create(({ tokens }) => {
    const modal = useModal();
    const dialogRef = useRef(null);

    const [values, setValues] = useState(() => {
        var initial = {};
        (tokens || []).forEach((token) => {
            initial[token.name] = "";
        });
        return initial;
    });

    const close = (isConfirmed) => {
        modal.resolve(isConfirmed ? { isConfirmed: true, values } : { isConfirmed: false });
        modal.remove();
    };

    // Fill each placeholder input with its placeholder token name (e.g., {{SomeToken}} -> "SomeToken") in one click.
    const applyTokenNameToAllValues = () => {
        setValues((prev) => {
            var next = { ...prev };
            (tokens || []).forEach((token) => {
                next[token.name] = token.name;
            });
            return next;
        });
    };

    useEffect(() => {
        var dialog = dialogRef.current;

        var onKeyDown = (e) => {
            if (e.key === "Escape") {
                close(false);
            }
        };

        dialog.addEventListener("keydown", onKeyDown);
        dialog.showModal();

        return () => {
            dialog.removeEventListener("keydown", onKeyDown);
        };
    }, []);

    return (
        <dialog ref={dialogRef} className="download-tokens-dialog">
            <header>
                <div className="dialog-title">Enter Token Values</div>
                <div className="close-button" onClick={() => close(false)}>
                    <X size={16} />
                </div>
            </header>
            <div className="dialog-content download-tokens-content">
                <p className="download-tokens-description">
                    This article contains the following placeholders. Enter a value for each one to
                    generate the PDF with them filled in.
                </p>
                {(tokens || []).map((token) => (
                    <div className="download-tokens-field" key={token.id}>
                        <label htmlFor={`token-${token.id}`}>{token.name}</label>
                        <input
                            id={`token-${token.id}`}
                            className="control"
                            type="text"
                            autoComplete="off"
                            value={values[token.name] || ""}
                            onChange={(e) => {
                                var value = e.target.value;
                                setValues((prev) => ({ ...prev, [token.name]: value }));
                            }}
                        />
                    </div>
                ))}
            </div>
            <footer className="dialog-buttons">
                <button className="btn btn-primary" onClick={applyTokenNameToAllValues}>
                    Apply all token names
                </button>
                <button className="btn btn-primary" onClick={() => close(true)}>
                    <span className="text-icon">
                        <Download size={16} />
                        <div>Download</div>
                    </span>
                </button>
                <button className="btn btn-secondary" onClick={() => close(false)}>
                    Cancel
                </button>
            </footer>
        </dialog>
    );
});